import {SlButton, SlCheckbox, SlDialog, SlInput} from '../../../../vendor/plugins/clxFrontendCms/public/js/shoelace/shoelace';
import {notNull} from '../../../../vendor/plugins/clxMobileNetPortable/assets/responsive/js/common/assert';
import {CookieManager} from '../common/cookieManager';

export class UserRegistrationDialog {
    private readonly SAVE_USER_MAIL_ACTION = '/modulcmsapi/save-user-email/';
    private readonly SAVE_MICRO_ACTION = '/merkliste/save_microconversion';
    private readonly EMAIL_REGEX = /\S+@\S+\.\S+/;

    private readonly userRegistrationDialog: SlDialog | null;
    private readonly vvlForm: HTMLFormElement | null;

    private readonly cookieManager: CookieManager;
    private readonly cookieRegistrationLayerDismissed = 'REGISTER_LAYER_DISMISSED';

    constructor() {
        this.cookieManager = new CookieManager();
        this.userRegistrationDialog = document.querySelector('.save-user-layer-dialog');
        this.vvlForm = document.querySelector('#vvl_to_early');

        this.init();
    }

    private init(): void {
        if (this.vvlForm) {
            const form = this.vvlForm;
            // event submit form
            form.addEventListener('submit', (event) => {
                event.preventDefault();
                event.stopPropagation();
                event.stopImmediatePropagation();
                this.saveVvlForm(form);
            });
        }
        const userRegistrationDialog = this.userRegistrationDialog;
        if (!userRegistrationDialog) {
            return;
        }

        const saveUserLayerOpen: SlButton | null = document.querySelector('sl-button.save-user-layer-open');
        saveUserLayerOpen?.addEventListener('click', (event) => {
            event.preventDefault();

            userRegistrationDialog.show();

            this.saveMircoconversion(saveUserLayerOpen as SlButton);

            this.cookieManager.setCookie(this.cookieRegistrationLayerDismissed, 'true');
        });

        const close: HTMLLinkElement | null = userRegistrationDialog.querySelector('.close-link');
        close?.addEventListener('click', (event) => {
            event.preventDefault();

            userRegistrationDialog.hide();
        });

        const email = notNull(userRegistrationDialog.querySelector('sl-input[type="email"]')) as SlInput;
        const submitButton = notNull(userRegistrationDialog.querySelector('sl-button.submit')) as SlButton;

        // wenn enter gedrueckt wird, soll der submit button geklickt werden
        email.addEventListener('keydown', (event) => {
            if (event.key === 'Enter') {
                event.preventDefault();

                submitButton?.click();
            }
        });

        submitButton.addEventListener('click', (event) => {
            event.preventDefault();

            if (!this.validateFields(email)) {
                return;
            }

            const formData = new FormData();
            formData.append('email', email.value);
            formData.append('art', email.dataset.art ?? '');
            formData.append('typ', email.dataset.typ ?? '');

            fetch(this.SAVE_USER_MAIL_ACTION, {
                method: 'POST',
                body: formData,
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                },
                cache: 'default',
                credentials: 'same-origin',
            })
                .then((response) => response.json())
                .then(({showMessage}) => {
                    if (showMessage === true) {
                        let message = `
                            <div slot="label">Du hast Post!</div>
                            <div class="dialog-head success">
                                <img src="/img/merkliste/envelope-heart.png">
                            </div>
                            <div class="dialog-content success">
                                Best\xE4tige bitte Deine E-Mail \xFCber den Link, den wir Dir geschickt haben.<br>
                                Nichts im Posteingang? Dann pr\xFCfe den Spam-Ordner, eventuell ist unsere Nachricht dort gelandet. Der Link ist 24 Stunden g\xFCltig.
                        `;

                        if (email.dataset.art === 'SUCHE') {
                            let url = email.dataset.typ === 'DSL' ? '/internet.html' : '/tarife.html';
                            message =
                                message +
                                `
                                <div class="link-container">
                                    <sl-button href="/merkliste.html" type="button" class="secondary" size="small">
                                        zur Merkliste
                                        <span slot="suffix" class="chevron"></span>
                                    </sl-button>
                                    <sl-button class="button-primary" href="${url}" type="button"  size="small" variant="primary">
                                        zur Tarif\xFCbersicht
                                        <span slot="suffix" class="chevron"></span>
                                    </sl-button>
                                </div>
                            `;
                        } else {
                            let url = email.dataset.typ === 'DSL' ? '/internet.html' : '/tarife.html';
                            message =
                                message +
                                `
                                <div class="link-container">
                                    <sl-button href="${url}" type="button" class="secondary" size="small">
                                        zur Tarif\xFCbersicht
                                        <span slot="suffix" class="chevron"></span>
                                    </sl-button>
                                    <sl-button class="button-primary" href="/merkliste.html" type="button"  size="small" variant="primary">
                                        zur\xFCck zur Merkliste
                                        <span slot="suffix" class="chevron"></span>
                                    </sl-button>
                                </div>
                            `;
                        }

                        message = message + '</div>';

                        // zeige erfolgs message an
                        userRegistrationDialog.innerHTML = message;
                    }

                    const teaser: HTMLElement | null = document.querySelector('.save-user-layer');
                    if (!teaser) {
                        return;
                    }

                    teaser.style.display = 'none';

                    const merklisteContainer: HTMLElement | null = teaser.closest('.merkliste-teaserbox');
                    if (merklisteContainer) {
                        // we can't use display none, because the dialog is inside the merklisteContainer.
                        merklisteContainer.style.height = '0';
                        merklisteContainer.style.margin = '0';
                        merklisteContainer.style.padding = '0';
                        merklisteContainer.style.border = 'none';
                    }
                });
        });
    }

    private validateFields(email: SlInput): boolean {
        if (email.value === '') {
            email.setCustomValidity('Bitte g\xFCltige E-Mail-Adresse eingeben.');
            email.reportValidity();

            return false;
        }

        if (!this.EMAIL_REGEX.test(email.value)) {
            email.setCustomValidity('Bitte g\xFCltige E-Mail-Adresse eingeben.');
            email.reportValidity();

            return false;
        }

        return true;
    }

    private saveVvlForm(form: HTMLFormElement) {
        const email = notNull(form.querySelector('sl-input[type="email"]')) as SlInput;

        if (!this.validateFields(email)) {
            return;
        }

        const formData = new FormData(form);

        fetch(this.SAVE_USER_MAIL_ACTION, {
            method: 'POST',
            body: formData,
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
            },
            cache: 'default',
            credentials: 'same-origin',
        })
            .then((response) => response.json())
            .then(({showMessage}) => {
                if (showMessage === true) {
                    const ToEarlySuccessLayer = notNull(document.querySelector('#ToEarlySuccessLayer')) as SlDialog;
                    ToEarlySuccessLayer.show();
                    const backbutton = notNull(ToEarlySuccessLayer.querySelector('.back-button')) as SlButton;
                    backbutton.addEventListener('click', (event) => {
                        event.preventDefault();
                        email.value = '';
                        ToEarlySuccessLayer.hide();
                    });
                }
            });
    }

    private saveMircoconversion(saveUserLayerOpen: SlButton): void {
        const formData = new FormData();
        formData.append('art', saveUserLayerOpen.dataset.art ?? '');
        formData.append('typ', saveUserLayerOpen.dataset.typ ?? '');

        fetch(this.SAVE_MICRO_ACTION, {
            method: 'POST',
            body: formData,
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
            },
            cache: 'default',
            credentials: 'same-origin',
        });
    }
}
